import { ProfilesDetailTemplate } from "../../Templates/ProfilesDetailTemplate";

export const ProfilesDetail = () => {
  return <ProfilesDetailTemplate />;
};
